import { render, staticRenderFns } from "./iconEdit.vue?vue&type=template&id=2a2e1b5a&scoped=true&"
import script from "./iconEdit.vue?vue&type=script&lang=js&"
export * from "./iconEdit.vue?vue&type=script&lang=js&"
import style0 from "./iconEdit.vue?vue&type=style&index=0&id=2a2e1b5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2e1b5a",
  null
  
)

export default component.exports